import { useReducer } from 'react';

import { ShareDialogAction, ShareDialogState } from './types';

const reducer = (
  state: ShareDialogState,
  action: ShareDialogAction
): ShareDialogState => {
  switch (action.type) {
    case 'Open':
      return {
        name: action.payload.name,
        quizId: action.payload.quizId,
        soc: action.payload.soc,
        isSharingEnabled: action.payload.isSharingEnabled,
        isShareDialogOpen: true,
      };
    case 'Close':
      return {
        name: '',
        quizId: null,
        soc: '',
        isSharingEnabled: false,
        isShareDialogOpen: false,
      };

    case 'ToggleSharing':
      return {
        ...state,
        isSharingEnabled: !state.isSharingEnabled,
      };
  }
};

export function useShareDialog() {
  const [shareDialogState, dispatch] = useReducer(reducer, {
    isShareDialogOpen: false,
    isSharingEnabled: false,
    name: '',
    quizId: null,
    soc: '',
  });

  const { isShareDialogOpen, isSharingEnabled, soc, quizId, name } =
    shareDialogState;

  return {
    dispatch,
    soc,
    isShareDialogOpen,
    isSharingEnabled,
    quizId,
    name,
  };
}
